<template>
    <Card :bordered="false" class="border-radius-0">
        <CTable
            :isLoading="isLoading"
            v-model:columns="state.columns"
            v-model:page="state.page"
            :options="state.tableOptions"
            :manages="state.manages"
            :manageExtras="state.manageExtras"
            :rowActions="state.rowActions"
            :visibleSearch="visibleSearch"
            @search="search => onSearch({ props, state, ...search })"
        ></CTable>
    </Card>
</template>

<script>
import { defineAsyncComponent, defineComponent } from "vue";
import { Card } from "ant-design-vue";
import { state as stateApp } from "../../../app.logic";
import { initState, isLoading, onSearch, state } from "./license.logic";

export default defineComponent({
    components: {
        Card,
        CTable: defineAsyncComponent(() => import("../../../components/table/CTable"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "licenses" },
        visibleSearch: { default: true },
    },
    setup(props) {
        initState({ props });
        return { props, isLoading, state, onSearch };
    }
});
</script>